import type { IApiError } from "draivn-ui-domain";

// draivn-onboarding COMMON_ERRORS.forbidden: activate_form returns it once
// t_form.approve or t_form.domain_id is set, i.e. the invite was completed.
export const ONBOARDING_TOKEN_CONSUMED_CODE = 1403;

const isConsumedTokenPayload = (payload: unknown): boolean =>
  typeof payload === "object" &&
  payload !== null &&
  (payload as { code?: unknown }).code === ONBOARDING_TOKEN_CONSUMED_CODE;

export const isCompletedInviteError = (
  errors: IApiError[] | null | undefined
): boolean =>
  Boolean(errors?.some((error) => error?.data?.some(isConsumedTokenPayload)));
